 
import axios, { AxiosRequestConfig } from "axios";

import { shouldLogoutForUnauthorizedResponse } from "utils/auth";
import { logOut } from "utils/utilis";

type ExtendedRequestConfig = AxiosRequestConfig;

export const bffBaseUrl =
  process.env.REACT_APP_BFF_BASE_URL || "";

export const coreUploadUrl = `${process.env.REACT_APP_BASE_URL || ""}/files/v1/upload`;

const safepro: any = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  timeout: 120000,
});

// Add a response interceptor
safepro.interceptors.response.use(function (response:any) {
  // Any status code that lie within the range of 2xx cause this function to trigger
  // Do something with response data
  // console.log("response >> interceptors", response);
  
  return response;
}, function (error:any) {
  // Any status codes that falls outside the range of 2xx cause this function to trigger
  // Do something with response error
  // console.log("error >> interceptors", error);
  if(shouldLogoutForUnauthorizedResponse(error)){
    logOut()
  }
  return Promise.reject(error);
});
export default safepro;

export const safeproMiddleWare: any = axios.create({
  baseURL: bffBaseUrl + "/api",
  timeout: 120000,
})

safeproMiddleWare.interceptors.request.use((config: ExtendedRequestConfig) => {
    try {
        if (!config) return config;
        const headers = (config.headers || {}) as Record<string, any>;
        const headerVersion = headers["x-api-version"] || headers["X-Api-Version"];
        if (headerVersion && typeof headerVersion === "string") {
            const rawUrl = config.url || "";
            // do not modify absolute URLs
            if (!/^https?:\/\//i.test(rawUrl)) {
                const normalizedUrl = rawUrl.startsWith("/") ? rawUrl.replace(/^\/+/, "") : rawUrl;
                config.url = `/${headerVersion}/${normalizedUrl}`.replace(/\/+/g, "/");
                // remove the header so backend doesn't receive it
                delete headers["x-api-version"];
                delete headers["X-Api-Version"];
                config.headers = headers;
            }
        }
    } catch (e) {
        // noop - leave config as-is
    }
    return config;
});

safeproMiddleWare.interceptors.response.use(function (response:any) {
  return response;
}, function (error:any) {
  if(shouldLogoutForUnauthorizedResponse(error)){
    logOut()
  }
  return Promise.reject(error);
});




export const safeproMiddleWare2: any = axios.create({
  baseURL: bffBaseUrl + "/api/v1",
  timeout: 120000,
})

safeproMiddleWare2.interceptors.response.use(function (response:any) {
  return response;
}, function (error:any) {
  if(shouldLogoutForUnauthorizedResponse(error)){
    logOut()
  }
  return Promise.reject(error);
});
